import AttachmentTaskActivityChecklistModal from './attachment-task-checklist.container'

export default AttachmentTaskActivityChecklistModal